import React from 'react';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';

import { PosPlugin } from 'plugins/plugin';
import { reactcursively } from 'utils/react';
import Icon from 'components/Icon';

import { updateCustomerInformation } from '../rdx/actions';

const CustomerViewIcons: PosPlugin['UICustomerViewIcons'] = ({
  children,
  customer,
}) => {
  const dispatch = useDispatch();
  const newChildren = reactcursively(
    R.pipe(
      R.when(
        R.pathEq(['props', 'data-testid'], 'customer-view-icons-container'),
        R.modifyPath(['props', 'children', 0], children => {
          return (
            <>
              <Icon
                style={{ paddingLeft: '12px', paddingRight: '12px' }}
                key="update_customer_via_display"
                name="icon_desktop"
                title="Update customer information"
                action={() => {
                  dispatch(updateCustomerInformation(customer));
                }}
                data-testid="update_customer_via_display"
              />
              {children}
            </>
          );
        }),
      ),
    ),
  )(children);

  return newChildren;
};

export default CustomerViewIcons;
